const additionalIndex = [1, 2, 3, 4, 5];
const state = {
  status: 0,
  order: {
    storeName: '',
    diningIn: {},
    items: [],
    paymentType: '',
    paymentCode: '',
    invoiceCarrierCode: '',
    invoiceDonateCode: '',
    invoiceBuyerVat: '',
    takeOutInfo: {},
    transactionPaymentList: [],
  },
  posResponse: null,
  paymentResponse: null,
  diningIn: '',
  cashType: '',
  isForKiosk: false,
};

const mutations = {
  SET_DINING_IN(state, content) {
    state.diningIn = content.key;
    state.order.diningIn = content.info;
  },
  SET_ORDER_CONTENT(state, content) {
    state.order = { ...state.order, ...content };
  },
  SET_ORDER_ITEM(state, content) {
    state.order.items.push(content);
  },
  SET_POS_RESPONSE(state, content) {
    state.posResponse = content;
  },
  SET_PAYMENT_RESPONSE(state, content) {
    state.paymentResponse = content;
  },
  SET_IS_FOR_KIOSK(state, content) {
    state.isForKiosk = content;
  },
  CLEAN_ALL(state) {
    state.status = 0;
    state.posResponse = null;
    state.paymentResponse = null;
    state.diningIn = '';
    state.cashType = '';
    state.isForKiosk = false;
    Object.keys(state.order)
      .forEach((key) => {
        if (Array.isArray(state.order[key])) {
          state.order[key] = []; // 陣列清空
        } else if (typeof state.order[key] === 'object' && state.order[key] !== null) {
          state.order[key] = {}; // 物件清空
        } else {
          state.order[key] = ''; // 其他型別清空
        }
      });
  },
  DEL_ORDER_ITEM(state, indexArray) {
    state.order.items = state.order.items.filter((_, index) => !indexArray.includes(index));
  },
  SET_CASHTYPE(state, content) {
    state.cashType = content;
  },
};

const actions = {
  // 從POS端資訊取得transactionTypeId & transactionTypeName (e.g. 內用、外帶)
  setDiningIn({
    commit,
    rootState,
  }, diningIn) {
    const transactionTypeName = (() => {
      switch (diningIn) {
        case 'for-here':
          return '內用';
        case 'to-go':
          return '外帶';
        case 'delivery':
          return '外送';
        default:
          return '';
      }
    })();
    if (transactionTypeName) {
      const posTypeInfo = rootState.PosInfo.profile.storeInfo.transactionType;
      const typeInfo = posTypeInfo.find((info) => info.transactionTypeName === transactionTypeName);
      commit('SET_DINING_IN', {
        key: diningIn,
        info: {
          transactionTypeId: typeInfo.transactionTypeId,
          transactionTypeName: typeInfo.transactionTypeName,
        },
      });
    }
  },
  setOrderContent({ commit }, payload) {
    commit('SET_ORDER_CONTENT', payload);
  },
  setOrderItem({ commit }, item) {
    commit('SET_ORDER_ITEM', item);
  },
  setPosResponse({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SET_POS_RESPONSE', payload);
      resolve();
    });
  },
  setPaymentResponse({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SET_PAYMENT_RESPONSE', payload);
      resolve();
    });
  },
  setIsForKiosk({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SET_IS_FOR_KIOSK', payload);
      resolve();
    });
  },
  cleanOrder({ commit }) {
    commit('CLEAN_ALL');
  },
  deleteOrderItem({ commit }, index) {
    commit('DEL_ORDER_ITEM', index);
  },
  setCashType({ commit }, payload) {
    commit('SET_CASHTYPE', payload);
  },
};

const getters = {
  orderItems: (state) => state.order.items,
  totalAmount: (state) => {
    const sum = state.order.items.reduce((accu, curr) => {
      let subTotal = 0;
      // 套餐
      if (curr.isGroup) {
        subTotal = curr.groupAmounts.reduce((subAccu, subCurr) => subAccu + subCurr, 0);
        return accu + subTotal;
      }
      // 單點附餐價格加總
      const additionalTotal = additionalIndex.reduce((subAccu, subCurr) => {
        let _price = 0;
        const _additionalItems = curr[`additionalOfProduct${subCurr}`];
        if (_additionalItems && _additionalItems.products) {
          _additionalItems.products.forEach((_item) => {
            if (_item.productPrice) _price += parseInt(_item.productPrice, 10);
          });
        }
        return subAccu + _price;
      }, 0);
      subTotal = parseInt(curr.productPrice, 10);
      return accu + subTotal + additionalTotal;
    }, 0);
    return sum;
  },
  totalServiceFee: (state, getters) => {
    const calFeeFunc = getters.calculateDefaultServiceFeeFunction;
    const decimalFunc = getters.decimalHandleFunction;
    const sum = state.order.items.reduce((accu, curr) => {
      let subTotal = 0;
      // 套餐服務每
      if (curr.isGroup) {
        subTotal = curr.groupAmounts.reduce((subAccu, subCurr) => subAccu + subCurr, 0);
        const _serviceCharge = curr.groupMainItem.serviceCharge;
        const _fee = calFeeFunc(subTotal, _serviceCharge, state.diningIn);
        return accu + _fee;
      }
      // 單點附餐價格加總
      const additionalTotal = additionalIndex.reduce((subAccu, subCurr) => {
        let _price = 0;
        const _additionalItems = curr[`additionalOfProduct${subCurr}`];
        if (_additionalItems && _additionalItems.products) {
          _additionalItems.products.forEach((_item) => {
            if (_item.productPrice) _price += parseInt(_item.productPrice, 10);
          });
        }
        return subAccu + _price;
      }, 0);
      subTotal = parseInt(curr.productPrice, 10) + additionalTotal;
      const _fee = calFeeFunc(subTotal, curr.serviceCharge, state.diningIn);
      return accu + _fee;
    }, 0);
    return decimalFunc(sum);
  },
  order: (state) => state.order,
  posResponse: (state) => state.posResponse,
  paymentResponse: (state) => state.paymentResponse,
  diningIn: (state) => state.diningIn,
  cashType: (state) => state.cashType,
  isForKiosk: (state) => state.isForKiosk,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
